<template>
    <div class="converting-updates">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="content-sm">
                        <SectionHeader
                            title="5 Steps to Building Converting Updates"
                            desc="Grow your revenue with each published update"/>
                        <Step
                            v-for="item in convertingUpdatesData" 
                            :key="item.step"
                            :data="item"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Step from './Step'
import SectionHeader from '../SectionHeader'
import {convertingUpdatesData} from '../landingPageData'
export default {
    name: 'ConvertingUpdates',
    components: {
        Step,
        SectionHeader
    },
    setup: function() {
        return {
            convertingUpdatesData
        }
    }
}
</script>
<style lang="scss" scoped>
.converting-updates {
    padding-top: 103px;
}
@media (max-width: 767px) {
    .converting-updates {
        padding-top: 56px;
    }
}
</style>